import React, { useState, useEffect, useCallback, useContext } from "react";
import moment from "moment";
import ProviderService from "../../../../../services/api/provider.service";
import AppointmentService from "../../../../../services/api/appointment.service";
import DoctorService from "../../../../../services/api/doctor.service";
import toast from "react-hot-toast";
import DimLoader from '../../../../templates/components/DimLoader'
const defaultState = {
    wholePractice: false,
    startWholeDay: false,
    endWholeDay: false,
    startDate: moment().format("YYYY-MM-DD"),
    startTime: '00:00',
    endDate: moment().format("YYYY-MM-DD"),
    endTime: '00:00',
    practiceLocationId: null  // Explicitly set to null initially
}
import HPTSelect from "../../../../templates/components/HPTSelect";
import PracticeLocationSelector from "../../../../templates/components/PracticeLocationSelector";
import { store } from "../../../../../context/StateProvider";
import { useGetLocationProviderServices } from "../../../../../services/cache/CacheService";
import CacheUtilities from "../../../../../services/cache/CacheUtilities";

import APIResponse from "../../../../templates/components/APIResponse";

const UnavailableBlockForm = (props) => {
const globalStateAndDispatch = useContext(store)
    const state = globalStateAndDispatch.state
    const [providerList, setProviderList] = useState();
    const [isLoadingProviders, setIsLoadingProviders] = useState(false);
    const [inputData, setInputData] = useState();
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [blockType, setBlockType] = useState(1)
    const [apiResponse, setApiResponse] = useState()
    const stateDoctorList = useGetLocationProviderServices();

    const onLocationChanged = (newLocationId) => {
        let updates = {
            practiceLocationId: newLocationId
        };

        // Only reset doctorId if changing TO a specific location
        // Don't reset if changing TO null (all locations) since that includes all providers
        if (newLocationId !== null) {
            updates.doctorId = null;
        }

        setInputData(prevData => ({
            ...prevData,
            ...updates
        }));
    }

    // Load provider list whenever location changes
    useEffect(() => {
        let isMounted = true;

        const loadProviders = async () => {
            try {
                setIsLoadingProviders(true);
                setProviderList(null); // Reset provider list before loading new data
                let providers;
                const currentLocationId = inputData?.practiceLocationId;

                // If no location selected, load all providers
                if (!currentLocationId) {
                    providers = await CacheUtilities.pullServiceForLocationData(null);
                } else {
                    // For specific location
                    if (currentLocationId === state.practiceLocationId) {
                        providers = stateDoctorList;
                    } else {
                        providers = await CacheUtilities.pullServiceForLocationData(currentLocationId);
                    }
                }

                // Only update if component is still mounted and we have valid providers
                if (isMounted && providers && Array.isArray(providers)) {
                    setProviderList(providers);
                    // console.log('Provider list updated:', providers);
                    // if (inputData?.doctorId) {
                    //     console.log('Looking for doctorId:', inputData.doctorId);
                    //     const foundProvider = providers.find(obj => obj.doctorId === inputData.doctorId || obj.id === inputData.doctorId);
                    //     console.log('Found provider:', foundProvider);
                    // }
                }
            } catch (error) {
                console.error('Error loading providers:', error);
                if (isMounted) {
                    setProviderList([]);
                }
            }
            finally {
                if (isMounted) {
                    setIsLoadingProviders(false);
                }
            }
        };

        loadProviders();

        // Cleanup function
        return () => {
            isMounted = false;
        };
    }, [inputData?.practiceLocationId, stateDoctorList]);

    // Update block type when provider or location changes
    useEffect(() => {
        const newBlockType = determineBlockType(inputData?.doctorId, inputData?.practiceLocationId);
        if (newBlockType !== blockType) {
            setBlockType(newBlockType);
        }
    }, [inputData?.doctorId, inputData?.practiceLocationId]);
    
        const [blockTypeOptions, setBlockTypeOptions] = useState([
        {
            value:1
        ,   label:'One Provider, One Location'
        },
        {
            value:2
        ,   label:'One Provider, All Locations'
        },
        {
            value:3
        ,   label:'All Providers, One Location'
        },
        {
            value:4
        ,   label:'All Locations and Providers'
        },
    ])
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }

    useEffect(() => {
        const initializeWithDefaults = (data) => {
            // First, create base state with defaults
            const baseState = { ...defaultState };
            
            // If we have a providerId from props, it takes precedence
            if (props.providerId) {
                baseState.doctorId = props.providerId;
            }
            
            // Merge the provided data, keeping its values and only filling in missing ones from baseState
            const mergedState = {
                ...data,
                ...Object.fromEntries(
                    Object.entries(baseState).filter(([key]) => !data.hasOwnProperty(key))
                )
            };
            
            initializeData(mergedState);
        };

        if (props.unavailableBlockId) {
            AppointmentService.getUnavailableBlock(props.unavailableBlockId)
                .then(res => {
                    initializeWithDefaults(res);
                })
                .catch(() => {
                    toast.error('Oops! Something went wrong');
                });
        } else {
            // If we have initial data, use it; otherwise use empty object
            const initialData = props.initialData || {};
            initializeWithDefaults(initialData);
        }            
    }, []);

    const initializeData = (newInputData) => {
        let newStateObject = { ...newInputData };
        console.log('Initializing data with:', newStateObject);
        // Only set practice location from state if we don't have any existing data
        if (!newStateObject.practiceLocationId && !newStateObject?.unavailableBlockId) {
            newStateObject.practiceLocationId = state.practiceLocationId;
        }

        // Handle time settings
        if (newStateObject?.startWholeDay) {
            newStateObject["startTime"] = ''
        }
        if (newStateObject?.endWholeDay) {
            newStateObject["endTime"] = ''
        }

        // Determine and set the block type based on current values
        const initialBlockType = determineBlockType(newStateObject?.doctorId, newStateObject?.practiceLocationId);
        setBlockType(initialBlockType);

        console.log('Setting input data with:', newStateObject);
        setInputData(newStateObject);
    };

    const onSubmit = () => {
        const payload = { ...inputData };
        //console.log(payload);
        setIsSubmitted(true)

        delete payload.wholePractice        

        // 'One Provider, One Location'
        if (blockType==1) {
            // 	ub.DoctorId is not null
            // 	ub.PracticeLocationId = _practiceLocationId
            // nothing to change - keep both doctor and location
        }
        // 'One Provider, All Locations'
        if (blockType==2) {
            // 	ub.DoctorId is not null
            // 	ub.PracticeLocationId is null
            delete payload.practiceLocationId;
        }
        // 'All Providers, One Location'
        if (blockType==3) {
            delete payload.doctorId;
            // 	ub.DoctorId is null
            // 	ub.PracticeLocationId = _practiceLocationId
        }
        // 'All Locations and Providers'
        if (blockType==4) {
            delete payload.doctorId;
            delete payload.practiceLocationId;
            payload.wholePractice = 1;
            // 	ub.DoctorId is null
            // 	ub.PracticeLocationId is null
        }
        // if (payload.wholePractice) {
        //     delete payload.practiceLocationId;
        // }

        if (!payload.doctorId) {
            delete payload.doctorId;
        }

        let startDateTime = ''
        let endDateTime = ''

        // "fromDate": Utilities.toISOStringWithoutOffset(new Date(data.fromDate))+'.000Z',
        // "toDate": Utilities.toISOStringWithoutOffset(new Date(data.toDate))+'.000Z',

        if (!payload.startTime) payload.startTime = ''
        if (!payload.endTime) payload.endTime = ''
        payload.endTime = payload.endTime.length==5 ? payload.endTime+':00': payload.endTime;
        payload.startTime = payload.startTime.length==5 ? payload.startTime+':00': payload.startTime;

        // Add blank time in case its missing
        if (!payload.startDate.includes("T")) {
            payload.startDate = payload.startDate + "T00:00:00.000Z"
        }
        if (!payload.endDate.includes("T")) {
            payload.endDate = payload.endDate + "T00:00:00.000Z"
        }

        if (payload.startWholeDay) {
            startDateTime = moment(payload.startDate)
            delete payload.startTime;
        }
        else {
            // startDateTime = moment.utc(payload.startDate.replace('00:00:00', payload.startTime + ':00').replace('T', ' ').replace('Z', '').replace('.000', ''), "YYYY-MM-DD hh:mm:ss", false)
            startDateTime = moment(payload.startDate.replace('00:00:00', payload.startTime))
        }

        if (payload.endWholeDay) {
            endDateTime = moment.utc(payload.endDate).endOf("d")
            delete payload.endTime;
        }
        else {
            // endDateTime = moment.utc(payload.endDate.replace('00:00:00', payload.endTime + ':00').replace('T', ' ').replace('Z', '').replace('.000', ''), "YYYY-MM-DD hh:mm:ss", false)
            endDateTime = moment(payload.endDate.replace('00:00:00', payload.endTime))
        }

        if (startDateTime > endDateTime) {
            toast.error('Start date/time cannot be greater than End date/time');
            setIsSubmitted(false)
            return;
        }

        payload.startDate = startDateTime.utc().format("YYYY-MM-DD")
        payload.endDate =  endDateTime.utc().format("YYYY-MM-DD")
        //payload.startTime = startDateTime.utc().format('HH:mm')
        //payload.endTime = endDateTime.utc().format('HH:mm')

        payload.wholePractice = payload.wholePractice ? 1 : 0;
        payload.startWholeDay = payload.startWholeDay ? 1 : 0;
        payload.endWholeDay = payload.endWholeDay ? 1 : 0;

        if (inputData?.unavailableBlockId) {
            ProviderService.editUnavailableBlock(inputData?.unavailableBlockId, payload)
                .then(data => {
                    setApiResponse(data)
                }).catch((error) => {
                    setApiResponse(error)
                })
                .finally(() => {
                    setIsSubmitted(false)
                });
        } else {
            ProviderService.addUnavailableBlock(payload)
                .then(data => {
                    //toast.success('Closed/Away Time added successfully');
                    setApiResponse(data)
                }).catch((error) => {
                    setApiResponse(error)
                })
                .finally(() => {
                    setIsSubmitted(false)
                });
        }
    }

const isFormValid = useCallback(() => {
        //console.log('Checking description:', !inputData?.description?.trim());
        if (!inputData?.description?.trim()) return false;
        
        //console.log('Checking startDate:', !inputData?.startDate);
        if (!inputData?.startDate) return false;
        
        //console.log('Checking endDate:', !inputData?.endDate);
        if (!inputData?.endDate) return false;
        
        // Check time requirements
        //console.log('Checking startTime requirement:', !inputData?.startWholeDay && !inputData?.startTime);
        if (!inputData?.startWholeDay && !inputData?.startTime) return false;
        
        //console.log('Checking endTime requirement:', !inputData?.endWholeDay && !inputData?.endTime);
        if (!inputData?.endWholeDay && !inputData?.endTime) return false;
        
        // Check location/provider requirements based on block type
        //console.log('Checking blockType:', blockType);
        if (blockType === 1) {
            // One Provider, One Location - both required
            return inputData?.doctorId && inputData?.practiceLocationId;
        } else if (blockType === 2) {
            // One Provider, All Locations - only provider required
            //console.log('Type 2 check:', inputData?.doctorId);
            return inputData?.doctorId;
        } else if (blockType === 3) {
            // All Providers, One Location - only location required
            //console.log('Type 3 check:', inputData?.practiceLocationId);
            return inputData?.practiceLocationId;
        } else if (blockType === 4) {
            // All Locations and Providers - neither required
            //console.log('Type 4 check: true');
            return true;
        }
        
        return false;
    }, [inputData, blockType]);

    const inputChange = (e) => {
        let newStateObject = { ...inputData };
        newStateObject[e.target.name] = e.target.value
        if (e.target.name == 'startWholeDay')
        {
            newStateObject['startTime'] = ''
        }
        if (e.target.name == 'endWholeDay')
        {
            newStateObject['endTime'] = ''
        }
        setInputData(newStateObject);
    };

    const determineBlockType = (provider, location) => {
        //console.log('Determining block type for provider:', provider, 'location:', location);
        // Treat undefined and null the same way
        const hasProvider = provider != null && provider !== '';
        const hasLocation = location != null && location !== '';
        
        if (hasProvider && hasLocation) {
            return 1; // One Provider, One Location
        } else if (hasProvider && !hasLocation) {
            return 2; // One Provider, All Locations
        } else if (!hasProvider && hasLocation) {
            return 3; // All Providers, One Location
        } else {
            return 4; // All Locations and Providers
        }
    };
    
    // const blockTypeSelected = (newBlockType) => {
    //     // Block type is now determined automatically, so this function is kept
    //     // for compatibility but doesn't need to modify the state
    //     setBlockType(newBlockType);
    // };    
    
    return (
        <>
            {isSubmitted ? <DimLoader loadMessage="Processing..." /> : null}
    
    <div className="row d-flex">
                <div className="col-12">
                    <label>Closed/Away Type</label>
            <HPTSelect
                className='react-select-container col'
                classNamePrefix='react-select'
                isDisabled={true}
                options={blockTypeOptions}
                name="blockType"
                value={blockTypeOptions.find(obj => obj.value === blockType)}
                getOptionLabel={(option) => { return (option.label) }}
                menuPortalTarget={document.body}
                // onChange={e => {
                //     blockTypeSelected(e.value);
                // }}
            />
        </div>

        <div className="col-12 required field">
                    <label>Description</label>
            <input
                placeholder="Description"
                type="text"
                name="description"
                value={inputData?.description}
                onChange={inputChange}
                required
            />
        </div>

        <div className="col-12">
            <label>Practice Location</label>
            <PracticeLocationSelector 
                locationId={inputData?.practiceLocationId ? inputData?.practiceLocationId : null} 
                isClearable={true} 
                placeholder={inputData?.doctorId ? "All Practice Location" : "Whole Practice"}
                dontResetState={true} 
                onSelected={(locationId) => {
                    onLocationChanged(locationId);
                    const newBlockType = determineBlockType(inputData?.doctorId, locationId);
                    setBlockType(newBlockType);
                }} 
            />
        </div>

        <div className="col-12">
            <label>Provider</label>
            <HPTSelect
                className="react-select-container"
                classNamePrefix="react-select"
                options={providerList}
                //isDisabled={!providerList}
                isClearable={true}
                isSearchable
                name="doctorId"
                loadingMessage="Providers are loading..."
                placeholder={"All"}
                isLoading={isLoadingProviders}
                value={providerList && (inputData?.doctorId) ? providerList.find(obj => obj.doctorId === inputData?.doctorId || obj.id === inputData?.doctorId) : null}
                onChange={e => {
                    const providerId = e?.doctorId || e?.id || null;
                    inputChange({
                        target: { 
                            value: providerId, 
                            name: 'doctorId' 
                        }
                    });
                    const newBlockType = determineBlockType(providerId, inputData?.practiceLocationId);
                    setBlockType(newBlockType);
                }}
                getOptionLabel={(option) => option.firstName + ' ' + option.lastName}
                getOptionValue={(option) => option.doctorId}
            />
        </div>

        <div className="field required col-6">
            <label>Start Date</label>
            <input type="date"
                className="form-control"
                value={inputData?.startDate ? moment.utc(inputData?.startDate).format("YYYY-MM-DD") : ''}
                min={moment().format("YYYY-MM-DD")}
                placeholder="MM/DD/YYYY"
                onChange={e => {
                    e.preventDefault();
                    inputChange({
                        target:
                            { value: e.target.value, name: 'startDate' }
                    })
                }}
            />
        </div>
        <div className="field required col-4">
            <label>Start Time</label>
            <input type="time"
                className="form-control"
                value={inputData?.startTime}
                min="1900-01-01"
                onChange={e => {
                    e.preventDefault();
                    inputChange({
                        target:
                            { value: e.target.value, name: 'startTime' }
                    })
                }}
                disabled={inputData?.startWholeDay}
            />
        </div>
        <div className="mt-4 col-2 d-flex align-items-center">
            <input
                type="checkbox"
                className="form-check-input"
                name="startWholeDay"
                checked={inputData?.startWholeDay}
                onChange={e => {
                    // e.preventDefault()
                    inputChange({
                        target:
                            { value: e.target.checked, name: 'startWholeDay' }
                    })
                }}
            />
            <label className="form-check-label ms-4">
                From Start of Day
            </label>
        </div>

        <div className="field required col-6">
            <label>End Date</label>
                    <input 
                        type="date"
                className="form-control"
                value={inputData?.endDate ? moment.utc(inputData?.endDate).format("YYYY-MM-DD") : ''}
                min={moment().format("YYYY-MM-DD")}
                placeholder="MM/DD/YYYY"
                onChange={e => {
                    e.preventDefault();
                    inputChange({
                        target:
                            { value: e.target.value, name: 'endDate' }
                    })
                }}
            />
        </div>
        <div className="field required col-4">
            <label>End Time</label>
            <input type="time"
                className="form-control"
                value={inputData?.endTime}
                min="1900-01-01"
                // max={moment().format("YYYY-MM-DD")}
                // placeholder="MM/DD/YYYY"
                onChange={e => {
                    e.preventDefault();
                    inputChange({
                        target:
                            { value: e.target.value, name: 'endTime' }
                    })
                }}
                disabled={inputData?.endWholeDay}
            />
        </div>
        <div className="col-2 mt-4 d-flex align-items-center">
            <input
                type="checkbox"
                className="form-check-input"
                name="endWholeDay"
                checked={inputData?.endWholeDay}
                onChange={e => {
                    // e.preventDefault()
                    inputChange({
                        target:
                            { value: e.target.checked, name: 'endWholeDay' }
                    });
                }}
            />
            <label className="form-check-label ms-4">
                To End of Day
            </label>
        </div>
    </div>
    <div className="mt-3 d-flex justify-content-between modal-button-bar">
        <div className="col-auto">
            <button
                className="btn btn-primary"
                disabled={!isFormValid()}
                onClick={(e) => {
                    e.preventDefault();
                    onSubmit();
                }}
            >
                {props?.unavailableBlockId ? 'Update' : 'Save'}
            </button>
        </div>
        <div className="col-auto">
            <button
                className="btn btn-secondary"
                onClick={(e) => {
                    e.preventDefault();
                    if (props.onClose) {
                        props.onClose()
                    }
                }}
            >
                Close
            </button>
        </div>
    </div>
    <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
    </>
    );
}

export default UnavailableBlockForm;
